export function watch() {

    let html = document.documentElement;
    let body = document.body;
    let content = document.getElementById("content");
    let targets = document.querySelectorAll('[height_viewport]');

    if(typeof content === 'undefined' || content == null) {
        return;
    }

    let browser = {
        width: window.innerWidth || document.body.clientWidth,
        height: window.innerHeight || document.body.clientHeight
    };

    targets.forEach(function (elm) {
        elm.style.minHeight = 'unset';
    });


    let height = (content.offsetHeight);

    if(height > browser.height) {
        html.style.height = height + 'px';
        body.style.minHeight = height + 'px';
        targets.forEach(function (elm) {
            elm.style.minHeight = height + 'px';
        });
    } else {
        html.style.height = '100vh';
        body.style.minHeight = '100vh';
        targets.forEach(function (elm) {
            elm.style.minHeight = '100vh';
        });
    }

    return true;
}